import {createSelector} from 'reselect'

const settingsSelector = state => state.settings

export const getSettingsData = createSelector(
    settingsSelector,
    settings => settings
)
